export default {
  "content": "<path fill=\"#000\" d=\"M6.234 3.988c.655 0 1.478-.443 1.967-1.034.444-.536.767-1.285.767-2.033A1.4 1.4 0 008.94.635c-.73.027-1.607.49-2.134 1.108-.415.472-.794 1.21-.794 1.968 0 .111.018.222.028.259.046.009.12.018.194.018zm-2.31 11.179c.896 0 1.293-.6 2.411-.6 1.136 0 1.386.581 2.384.581.979 0 1.635-.905 2.254-1.792.693-1.016.979-2.014.997-2.06-.064-.019-1.94-.785-1.94-2.938 0-1.866 1.479-2.707 1.562-2.772-.98-1.404-2.467-1.44-2.873-1.44-1.1 0-1.996.664-2.56.664-.61 0-1.413-.628-2.364-.628-1.811 0-3.65 1.497-3.65 4.324 0 1.755.684 3.612 1.525 4.813.72 1.016 1.349 1.848 2.254 1.848z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 12 16"
  }
};